module.exports = __webpack_public_path__ + "img/Inventory.be2f40b8.png";